import app from '../../../../package.json'
import type { Instance, RequestConfig } from '../providers/axios'

const env = process.env.TARGET_ENV

const APP_VERSION = env === 'production' ? process?.env?.PROJECT_VERSION : app?.version || ''

export const APP_FULL_NAME = `${app?.name}_v${APP_VERSION}_${env}` ?? ''

export interface HttpProvider {
  create: (config: RequestConfig) => Instance
}
